export * as Dialog from './styled/dialog';
